import React from "react";
/* eslint-disable */
import Header from "../../header";
import Banner from ".././Banner";
import SubNav from ".././SubNav";
import Footer from "../../Footer";

const icon = require("../../../assets/Detasad Cloud/main_icon_highperformance.svg");

const PrivateCloud = () => {
    const heading = `PRIVATE CLOUD`;
    const details = `Get the agility of Cloud with DETASAD Private Cloud, purpose built for your requirements.`;

    const overview = [
        `DETASAD Private Cloud service combines a private cloud platform with best of breed technology implementations. This powerful combination equips your business with the tools to rapidly build, control and customize your IT environment.`,
        `DETASAD Private Cloud is cost effective as it eliminates the capital burden of investing in expensive physical servers that often go underutilized. Every component of DETASAD Private Cloud supports the demands placed on your infrastructure without the burden of long-term contracts or the lead time of traditional deployments.`
    ];

    const advantages = [
        [
            `Dedicated Hardware`,
            `Your hardware is not shared with other customers, so you get predictable performance and security, while simplifying software licensing.
            `,
            icon
        ],
        [
            `24x7x365 Support`,
            `Our specialists proactively monitor and maintain the health of your private cloud and are available 24x7x365.`,
            icon
        ],
        [
            `Hardware on Demand`,
            `You can easily scale out or scale in your private cloud by adding/removing servers when required.`,
            icon
        ],
        [
            `Security & Compliance`,
            `The power of DETASAD Private Cloud is further enhanced with our services like Managed Security to provide deep expertise and advanced threat intelligence for help protecting your business.`,
            icon
        ]
    ];

    const functions = [
        [
            `Choice in Hypervisors`,
            [
                `DETASAD offers its customers the choice of selecting the hypervisors as per their requirements. You can select among OpenStack, VMWare ESXi and RedHat Virtualization as hypervisors according to your needs.`
            ]
        ],
        [
            `Privacy`,
            [
                `DETASAD considers the data of their customers to be highly sensitive. Our Private Cloud solutions provide businesses greater control over their data, in addition to ensuring data privacy. DETASAD ensures that your data does not leave your country under any circumstances.`
            ]
        ],
        [
            `Security`,
            [
                `DETASAD's Private Cloud solution ensures security of your data by making sure that data is saved and managed on servers to which no other company has access. The servers are managed by an internal IT team. Therefore, you should not need to worry about the physical security of your private cloud infrastructure.`
            ]
        ]
    ];

    const cfdetails = [
        `DETASAD offers its customers the choice of selecting the hypervisors as per their requirements. One of the reasons to choose the hypervisor of your choice is in case you already use virtual machines locally. It is essential for you to be able to import virtual machine images as it is necessary to maintain the hypervisor already used locally, since it is not possible to use images created with different hypervisors.
    DETASAD’s Private Cloud solution is provisioned using the latest hardware and software technology, using a custom hypervisor of your choice. You can select any supported hypervisor to increase flexibility and portability. The supported hypervisors are given below:`
    ];

    return (
        <div>
            <Header />
            <Banner heading={heading} details={details} />
            <SubNav
                overview={overview}
                advantages={advantages}
                functions={functions}
                // functionsDetailed={cfdetails}
            />
            <Footer />
        </div>
    );
};

export default PrivateCloud;
